module.exports = __webpack_public_path__ + "img/sp.a776e519.png";